module.exports = __webpack_public_path__ + "media/images/flags/eg-e2f38452954f3ffbc73786563256ab31.svg";